module.exports = __webpack_public_path__ + "img/source-icon.e6d7932f.png";